(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hjertelig-bildehjul"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function start(root) {
      if (!root || root.dataset.hjulKlar) return;
      root.dataset.hjulKlar = '1';
      root.classList.add('hj-hjul--js');

      var ring = root.querySelector('[data-hjul-ring]');
      if (!ring) return;

      var rolig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var spin = 0, vel = 0;
      var fliser = [].slice.call(ring.querySelectorAll('figure'));
      var n = fliser.length || 1;
      var cs = getComputedStyle(root);
      var tall = function (navn, standard) {
        var v = parseFloat(cs.getPropertyValue(navn));
        return isNaN(v) ? standard : v;
      };
      var drift = rolig ? 0 : (parseFloat(root.dataset.drift) || 0);
      var helning = tall('--hw-helning', -14) * Math.PI / 180;
      var flat    = tall('--hw-flat', 0.44);
      var sNaer   = tall('--hw-naer', 1.42);
      var sFjern  = tall('--hw-fjern', 0.66);
      var fokusK  = tall('--hw-fokus', 4);
      var maksUskarp = rolig ? 0 : tall('--hw-uskarp', 1.6);
      var kos = Math.cos(helning), sin = Math.sin(helning);
      var iSyne = false, kjorer = false, drar = false;

      function tegn() {
        var boks = ring.getBoundingClientRect();
        /* Uten denne vakten kollapser hele hjulet til midten: rx regnes av
           bredden, og er bredden 0 når første tegning skjer, får alle seksten
           flisene translate(0,0) og blir liggende oppå hverandre. Det er
           akkurat det som skjedde — seksjonen ligger under folden, så
           IntersectionObserver hadde ikke utløst ennå, og den ene tegningen
           som kjørte, kjørte for tidlig. ResizeObserver nedenfor tegner om
           så snart boksen får mål. */
        if (!boks.width) return;
        var rx = boks.width * 0.45, ry = rx * flat;
        // Uskarphet som følger farten. Leseren ser ikke sløret — de ser fart.
        var uskarp = Math.min(maksUskarp, Math.abs(vel) * 0.22);
        for (var k = 0; k < n; k++) {
          var t = (k / n) * Math.PI * 2 + spin * Math.PI / 180;
          var ex = Math.cos(t) * rx, ey = Math.sin(t) * ry;
          var x = ex * kos - ey * sin;          // skråstill hele banen
          var y = ex * sin + ey * kos;
          var naerhet = (Math.sin(t) + 1) / 2;  // 1 nederst = nærmest oss
          /* Størrelsen følger IKKE nærheten rett av. Med en rett linje blir
             alle bildene omtrent like store hele veien rundt, og ingen får
             være hovedpersonen. Med en potenskurve ligger nesten hele veksten
             i de siste gradene før bunnen: ett bilde løftes fram, blir tydelig
             større enn naboene, og legger seg tilbake. Overgangen blir også
             roligere, fordi endringen skjer der bildet beveger seg saktest. */
          var sk = sFjern + (sNaer - sFjern) * Math.pow(naerhet, fokusK);
          // Litt egen helning per flis, deterministisk av indeksen — ingen
          // tilfeldighet, samme hver gang, men ikke maskinstilt.
          var vri = (helning * 180 / Math.PI) * 0.45 + ((k % 3) - 1) * 1.8;
          var f = fliser[k];
          f.style.transform = 'translate(-50%,-50%) translate(' + x.toFixed(1) + 'px,' +
            y.toFixed(1) + 'px) rotate(' + vri.toFixed(2) + 'deg) scale(' + sk.toFixed(3) + ')';
          f.style.zIndex = String(10 + Math.round(naerhet * 80));
          f.style.filter = uskarp > 0.05 ? 'blur(' + uskarp.toFixed(2) + 'px)' : '';
          f.style.opacity = (0.66 + 0.34 * Math.pow(naerhet, 1.5)).toFixed(3);
        }
      }

      function loop() {
        kjorer = false;
        if (!drar) {
          spin += vel + drift;
          vel *= 0.94;                       // friksjon: glir ut, stopper
          if (Math.abs(vel) < 0.004) vel = 0;
        }
        tegn();
        // Kjør bare videre når det skjer noe, og bare når noen ser det.
        if (iSyne && (drar || vel !== 0 || drift !== 0)) kjor();
      }
      function kjor() { if (!kjorer) { kjorer = true; requestAnimationFrame(loop); } }

      /* Vinkelen regnes i ellipsens eget rom: skråstillingen tas ut og
         y-aksen strekkes tilbake. Uten det føles dragingen rykkete på den
         flate delen av banen. */
      function vinkel(e) {
        var b = ring.getBoundingClientRect();
        var dx = e.clientX - (b.left + b.width / 2);
        var dy = e.clientY - (b.top + b.height / 2);
        var ux = dx * kos + dy * sin;
        var uy = (-dx * sin + dy * kos) / (flat || 1);
        return Math.atan2(uy, ux) * 180 / Math.PI;
      }

      var forrigeVinkel = 0, sisteDelta = 0, pekerId = null;
      // Stopper nettleserens egen bildedragning før den rekker å begynne.
      ring.addEventListener('dragstart', function (e) { e.preventDefault(); });
      ring.addEventListener('pointerdown', function (e) {
        e.preventDefault();
        drar = true; pekerId = e.pointerId;
        forrigeVinkel = vinkel(e); sisteDelta = 0; vel = 0;
        try { ring.setPointerCapture(pekerId); } catch (_) {}
        kjor();
      });
      ring.addEventListener('pointermove', function (e) {
        if (!drar || e.pointerId !== pekerId) return;
        var v = vinkel(e), d = v - forrigeVinkel;
        if (d > 180) d -= 360; else if (d < -180) d += 360;   // rundt 180°-skillet
        spin += d; sisteDelta = d; forrigeVinkel = v;
        tegn();
      });
      function slipp(e) {
        if (!drar || (e && pekerId !== null && e.pointerId !== pekerId)) return;
        drar = false;
        if (!rolig) vel = Math.max(-9, Math.min(9, sisteDelta));  // kast videre
        pekerId = null; kjor();
      }
      ring.addEventListener('pointerup', slipp);
      ring.addEventListener('pointercancel', slipp);

      var sisteY = window.scrollY, venter = false;
      if (!rolig) {
        window.addEventListener('scroll', function () {
          if (venter) return; venter = true;
          requestAnimationFrame(function () {
            venter = false;
            var y = window.scrollY, d = y - sisteY; sisteY = y;
            if (!iSyne) return;
            vel += Math.max(-14, Math.min(14, d)) * 0.05;
            vel = Math.max(-9, Math.min(9, vel));
            kjor();
          });
        }, { passive: true });
      }

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (poster) {
          poster.forEach(function (p) {
            iSyne = p.isIntersecting;
            if (iSyne) { root.classList.add('hj-hjul--klar'); kjor(); }
          });
        }, { threshold: 0.05 }).observe(root);
      } else {
        iSyne = true; root.classList.add('hj-hjul--klar'); kjor();
      }

      window.addEventListener('resize', tegn);
      // Fanger både første oppmåling og alle senere endringer, uten å vente
      // på at leseren scroller seksjonen inn i syne.
      var boksEl = root.querySelector('.hj-hjul__boks');
      if (window.ResizeObserver && boksEl) new ResizeObserver(tegn).observe(boksEl);
      tegn();
    }

    function alle() {
      var r = document.querySelectorAll('.hj-hjul');
      for (var i = 0; i < r.length; i++) start(r[i]);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alle);
    else alle();
    document.addEventListener('shopify:section:load', function (e) {
      var r = (e.target || document).querySelectorAll('.hj-hjul');
      for (var i = 0; i < r.length; i++) start(r[i]);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
